export function canInitiateSubcontractPayment(sc, milestone, canApprove) {
  // 用户本轮要求：特批只放行当前版本原合同款，仍保留未签状态；历史无双签记录沿用旧规则。
  if (!sc.signing || sc.signing.status === 'completed') return true;
  return milestone?.kind !== 'change_order' && sc.unsignedPaymentApprovalCurrent === true && canApprove === true;
}
